import 'core-js/stable';
import ServicePlan from './service-plan';

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.service-plan-spa').forEach((el) => (el.classList.contains('load') ? new ServicePlan(el) : null));
});
